import axios from "axios";
import { API } from "./api";

export const TENANT_TOKEN_KEY = "tg_tenant_token";
export const getTenantToken = () => localStorage.getItem(TENANT_TOKEN_KEY);
export const setTenantToken = (t) => localStorage.setItem(TENANT_TOKEN_KEY, t);
export const clearTenantToken = () => localStorage.removeItem(TENANT_TOKEN_KEY);

const th = () => ({ headers: { Authorization: `Bearer ${getTenantToken()}` } });

export const tenantLogin = (body) => axios.post(`${API}/tenant/login`, body).then((r) => r.data);
export const tenantRegister = (body) => axios.post(`${API}/tenant/register`, body).then((r) => r.data);
export const tenantMe = () => axios.get(`${API}/tenant/me`, th()).then((r) => r.data);
export const tenantReceipts = () => axios.get(`${API}/tenant/receipts`, th()).then((r) => r.data);
export const tenantReceiptUrl = (rid) =>
  `${API}/tenant/receipts/${rid}/pdf?auth=${encodeURIComponent(getTenantToken() || "")}`;
